import episodeModal from '@/utils/episodeModal';

export default {
    /**
     * Gets filtered list of episodes.
     *
     * @param   {object} state Vuex state.
     * @returns {object[]}     Filtered list of episodes.
     */
    filteredEpisodes(state) {
        return state.episodes.filter(function (episode) {
            if (episode.id !== episodeModal.getEpisodeData('id')) {
                return true;
            }

            // Hide original episode from episodes list in order to display
            // "Processing" one when reuploading audio file.
            return ! episodeModal.isAudioFileUploading();
        });
    },
};
